export default __webpack_public_path__ + "static/media/recommend.1eacb21d.svg";